import { AddressSimple } from "../../../api/types/address";
import { AddressBookCreatePayload, AddressBookUpdatePayload } from "../../../api/types/address-book";
import { regex } from "../../../common/regex";
import { FormErrors } from "../../FieldError";

export const validateAddressBook = (
  data: AddressBookUpdatePayload | AddressBookCreatePayload,
): [boolean, FormErrors<AddressSimple>] => {
  let errors: FormErrors<AddressSimple> = {}

  if (!data.name) {
    errors.name = "Název je povinné pole."
  }

  if (!data.zip) {
    errors.zip = "PSČ je povinné pole."
  }

  if (!data.country) {
    errors.country = "Stát je povinné pole."
  }

  if (!data.street) {
    errors.street = "Ulice a číslo domu je povinné pole."
  }

  if (!data.city) {
    errors.city = "Obec je povinné pole."
  }

  if (data.notifyPhone && !data.phone && !data.mobile) {
    errors.phone = "Telefon je povinné pole."
  }

  if (data.notifySMS && !data.mobile) {
    errors.mobile = "Mobil je povinné pole."
  } else if (data.notifyPhone && !data.phone && !data.mobile) {
    errors.mobile = "Mobil je povinné pole."
  }

  if (data.notifyEmail && !data.email) {
    errors.email = "E-mail je povinné pole."
  }

  if (data.email && !regex.email.test(data.email)) {
    errors.email = "E-mail je je ve špatném formátu."
  }

  return [Object.keys(errors).length === 0, errors]
}
